<template>
  <div class="content content--project-single">
    <OverlayLoader v-if="!$store.getters.hireRequestLoaded"></OverlayLoader>
    <MyHeader :breadcrumbItems="
      [

        {
          name: section.name,
          path: `/${$route.params.companySlug}/projects`
        },
        {
          name: 'Hiring Requests',
          path: `/${$route.params.companySlug}projects?tab=hiring-requests`
        },
        {
          name: hireRequest.role,
          path: `/${$route.params.companySlug}/hiring-requests/${hireRequest.idHireRequest}`
        },
      ]"/>

    <header class="content-header d-lg-none">
      <h1>{{hireRequest.role}}</h1>
    </header>

    <div class="container main-content">
      <div class="hero--project">
        <span class="hero-tag">Hiring Request</span>
        <span class="hero-title">{{hireRequest.role}}</span>
      </div>

      <div class="row">
        <div class="col-lg-5 offset-lg-1">
          <div class="section-people article-content" v-if="hireRequest.startDate">
            <h4>Start date</h4>
            <p v-html="hireRequest.startDate"></p>
          </div>
          <div class="section-people article-content" v-if="hireRequest.optionToExtend">
            <h4>Option to extend</h4>
            <p v-html="hireRequest.optionToExtend"></p>
          </div>
          <div class="section-people article-content" v-if="hireRequest.contact">
            <h4>Contact</h4>
            <p v-html="hireRequest.contact"></p>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="section-people article-content" v-if="hireRequest.endDate">
            <h4>End date</h4>
            <p v-html="hireRequest.endDate"></p>
          </div>
          <div class="section-people article-content" v-if="hireRequest.requestedSeniority">
            <h4>Requested seniority</h4>
            <p v-html="hireRequest.requestedSeniority"></p>
          </div>
          <div class="section-people article-content" v-if="hireRequest.clientContact">
            <h4>Client contact</h4>
            <p v-html="hireRequest.clientContact"></p>
          </div>
        </div>
        <div class="col-lg-10 offset-lg-1">
          <div class="section-people article-content" v-if="hireRequest.projectTaskDescription">
            <h4>Project / Task description</h4>
            <p v-html="hireRequest.projectTaskDescription"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import OverlayLoader from "@/components/general/OverlayLoader";
import {slugify} from "@/helpers/slugify";
export default {
  name: "HireRequest",
  components: {OverlayLoader, MyHeader},
  mounted() {
    this.getHireRequest();
  },
  watch: {
    '$store.getters.hireRequestLoaded'(val) {
      if (val) {
        window._paq.push(['setDocumentTitle', this.hireRequest.role]);
        window._paq.push(['trackPageView']);
      }
    }
  },
  computed: {
    hireRequest() {
      return this.$store.getters.hireRequest
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Projects'
      })
    },
  },
  methods: {
    getHireRequest() {
      this.$store.dispatch('getHireRequest', {_embed: 1, idHireRequest: this.$route.params.id})
    },
    slugify: slugify
  }
}
</script>
